import React from 'react';
import { usePlanRecommendation } from '@hooks/user.hook';
import { Button, LoadingScroll } from 'geniebook-ui/dist';
import { getPlanContent } from '@components/subscription/overview/detail/PlanContent';
import { useNavigate, useParams } from 'react-router-dom';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';
import { SUBJECT_ID_CHINESE_2 } from '@utils/constants/subject.constants';

const UpgradePlanAdvice = () => {
  const { subjectId } = useParams();
  const idSubject = subjectId
    ? subjectIdFromName(subjectId.toLowerCase())
    : undefined;
  const recommendedPlanQuery = usePlanRecommendation(
    true,
    idSubject == SUBJECT_ID_CHINESE_2,
  );
  const navigate = useNavigate();

  if (recommendedPlanQuery.isLoading) {
    return <LoadingScroll isBlockOthers={true} />;
  }

  if (recommendedPlanQuery.data?.data.data) {
    const items = getPlanContent(recommendedPlanQuery.data.data.data);

    return (
      <div
        className={
          'text-neutral-chalk max-lg:max-w-[350px] lg:max-w-[417px] w-full mx-auto'
        }
      >
        <div className={'max-lg:mb-8 lg:mb-10 text-center'}>
          <p
            className={
              'lg:font-bold max-lg:font-semibold lg:text-xl max-lg:text-lg leading-[1.2] mb-2'
            }
          >
            Upgrade your plan
          </p>
          <p className={'lg:leading-[22px] max-lg:text-xs max-lg:leading-4'}>
            Get the best plan for you with Geniebook{' '}
            {recommendedPlanQuery.data.data.data.subscription_plan_name}
          </p>
        </div>
        <div className={'mb-8 px-3'}>
          {items.map((item, index) => (
            <div
              key={index}
              className={
                'flex max-lg:pb-4 lg:pb-6 last-of-type:!pb-0 text-neutral-chalk'
              }
            >
              <div className={'w-[38px] mr-4'}>
                <img src={item.imageUrl} className={''} alt={''} />
              </div>
              <div>
                <div
                  className={
                    'lg:text-md lg:leading-[22px] max-lg:text-sm max-lg:leading[19px]'
                  }
                >
                  {item.main}
                </div>
                <div
                  className={
                    'lg:text-sm lg:leading-[19px] lg:font-bold max-lg:text-xs max-lg:leading[16px] max-lg:font-semibold text-primary-skyblue'
                  }
                >
                  {item.secondary}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div>
          <Button
            className={'!max-w-full !w-full'}
            onClick={() => navigate('/subscription')}
          >
            Go to subscription
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default UpgradePlanAdvice;
